// SIZE CHART HIDE BUTTON
// document.addEventListener("DOMContentLoaded", function () {
//   const triggerWrapper = document.querySelector(
//     ".product-content-container .product-block-area .product-page-popup-link"
//   );
//   const trigger = triggerWrapper.querySelector(
//     "button"
//   );
//   if (!trigger) return;

//   const maxWait = 5000;
//   const intervalTime = 200;
//   const start = Date.now();

//   const interval = setInterval(() => {
//     const modal = document.getElementById("modals-popup");
//     const sizeLabel = document.querySelector(
//         "variant-swatch-king .swatches .swatch-label"
//     );
//     if (!modal) return;

//     modal.classList.add("visually-hidden");
//     trigger.click();

//     const heading = modal.querySelector("h2");

//     if (heading) {
//       if (heading.textContent.trim() === "") {
//         triggerWrapper.style.display = "none";
//         modal.classList.add("is-empty");
//       } else {
//         sizeLabel.appendChild(triggerWrapper);
//       }

//       const closeBtn = modal.querySelector("button");
//       closeBtn?.click();
      
//       modal.classList.remove("visually-hidden")

//       clearInterval(interval);
//     } 

//     if (Date.now() - start > maxWait) {
//       console.log("Timed out waiting for modal content");
//       clearInterval(interval);

//       const closeBtn = modal.querySelector("button");
//       closeBtn?.click();
//       modal.classList.remove("visually-hidden")
//     }
//   }, intervalTime);
// });

// CHANGE CONTACT SUBMIT BUTTON TEXT
document.addEventListener("DOMContentLoaded", function () {
  const contactSubmitButton = document.querySelector(
    "#shopify-section-template--19012407918810__main section .theme-button"
  );

  if (!contactSubmitButton) {
    return;
  }

  contactSubmitButton.value = "SUBMIT";
});

/*::* INJECT CSS TO SHADOW DOM *::*/
document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver((mutationsList, observer) => {
    const form = document.querySelector("form-embed");

    if (form) {
      observer.disconnect();
      const shadow = form.shadowRoot;

      const style = document.createElement("style");
      style.textContent = `
        #form-container-ref * {
          font-family: "Inter", "sans-serif";
          box-sizing: border-box;
        }

        #form-container-ref [data-sizing="form-wrapper"] {
          max-width: min(100%, 70rem);
        }

        #form-container-ref [class*="_gridItem_"][class*="_gridItemContent_"] {
          padding-top: 0;
          padding-bottom: var(--spacing-2md);
          padding-left: var(--section-horizontal-spacing);
          padding-right: var(--section-horizontal-spacing);
        }

        #form-container-ref input,
        #form-container-ref button[aria-controls="country-selector-dropdown"] {
          padding-left: 0;
          padding-right: 0;
          border: none;
          background-color: unset;
          border-radius: 0;
          border-bottom: 0.1rem solid var(--color-black);
          box-shadow: unset;
          font-size: var(--font-size-body);
          line-height: var(--line-height-body);
          height: 5rem;
        }

        #form-container-ref label {
          left: 0;
          font-size: var(--font-size-body);
          line-height: var(--line-height-body);
        }

        #form-container-ref [class*="_formPhoneInputContainer_"] {
          grid-template-columns: 5rem 1fr;
        }

        #form-container-ref button[aria-controls="country-selector-dropdown"] {
          height: 5rem;
          max-height: unset;
        }

        #form-container-ref form {
          gap: var(--spacing-sm);
          flex-direction: row;
          flex-wrap: wrap;
        }

        #form-container-ref form > * {
          width: 100%;
        }

        @media (min-width: 991px) {
          #form-container-ref form > *:nth-child(-n + 4) {
            width: calc(50% - var(--spacing-sm) / 2);
          }
        }

        #form-container-ref [class*="_formFileInput_"] {
          position: relative;
        }

        #form-container-ref [class*="_formFileInput_"] > p {
          display: none;
        }

        #form-container-ref [class*="_formFileInput_"] > button {
          margin-top: 0;
          padding-left: 0;
          padding-right: 0;
          padding-top: var(--form-field-padding-top);
          padding-bottom: var(--form-field-padding-bottom);
          border: none;
          background-color: unset;
          border-radius: 0;
          border-bottom: 0.1rem solid var(--color-black);
          box-shadow: unset;
        }

        #form-container-ref [class*="_formFileInput_"] > button *:is([class*="_formFileInputFileName_"], [class*="_formFileInputButton_"]) {
          margin: 0;
          padding: 0;
          border-radius: 0;
          background-color: unset;
          width: 100%;
          display: flex;
          justify-content: space-between;
          font-size: var(--font-size-body);
          line-height: var(--line-height-body);
          text-align: start;
        }

        #form-container-ref [class*="_formFileInput_"] > button [class*="_formFileInputButton_"]:after {
          content: "";
          width: 1.4rem;
          height: auto;
          aspect-ratio: 1;
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><mask id="mask0_329_5186" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14"><rect width="14" height="14" fill="%23D9D9D9"/></mask><g mask="url(%23mask0_329_5186)"><path d="M10.116 9.06413C10.116 9.94768 9.81164 10.6995 9.20284 11.3197C8.59413 11.9399 7.84965 12.25 6.9694 12.25C6.08915 12.25 5.34277 11.9399 4.73027 11.3197C4.11777 10.6995 3.81152 9.94768 3.81152 9.06413V3.97119C3.81152 3.35422 4.02371 2.82975 4.44809 2.39779C4.87256 1.96593 5.39328 1.75 6.01025 1.75C6.62722 1.75 7.1479 1.96593 7.57227 2.39779C7.99674 2.82975 8.20898 3.35422 8.20898 3.97119V8.79492C8.20898 9.13743 8.08945 9.43245 7.85038 9.67998C7.6114 9.92751 7.32013 10.0513 6.97654 10.0513C6.63296 10.0513 6.3374 9.92945 6.08988 9.68581C5.84235 9.44217 5.71859 9.14521 5.71859 8.79492V3.94873H6.30192V8.79492C6.30192 8.9811 6.36565 9.13981 6.49311 9.27106C6.62066 9.40231 6.77753 9.46794 6.96371 9.46794C7.14999 9.46794 7.30686 9.40231 7.43431 9.27106C7.56187 9.13981 7.62565 8.9811 7.62565 8.79492V3.95996C7.62341 3.50671 7.46756 3.12229 7.15811 2.80671C6.84874 2.49113 6.46613 2.33333 6.01025 2.33333C5.55788 2.33333 5.17555 2.49302 4.86327 2.8124C4.551 3.13167 4.39486 3.51794 4.39486 3.97119V9.06413C4.39262 9.78435 4.64204 10.3982 5.14313 10.9056C5.64411 11.413 6.25423 11.6667 6.97348 11.6667C7.68243 11.6667 8.28506 11.413 8.78138 10.9056C9.2777 10.3982 9.52814 9.78435 9.53271 9.06413V3.94873H10.116V9.06413Z" fill="%231C1B1F"/></g></svg>');
        }

        #form-container-ref [class*="_formFileInput_"] > button [class*="_formFileInputFileName_"] > button {
          flex-shrink: 0;
        }

        #form-container-ref [class*="_formFileInput_"] > button [class*="_formFileInputButton_"] {
          color: transparent;
        }

        #form-container-ref [class*="_formFileInput_"] > button [class*="_formFileInputButton_"]:before {
          display: inline-block;
          position: absolute;
          top: var(--form-field-padding-top);
          left: 0;
          color: var(--color-black);
          opacity: 0.4;
        }

        #form-container-ref [class*="_formFileInput_"] > button[aria-label="Portfolio"] [class*="_formFileInputButton_"]:before {      
          content: "Portfolio (File types: pdf Max 5 MB)";
        }

        #form-container-ref [class*="_formFileInput_"] > button[aria-label="Resume/CV"] [class*="_formFileInputButton_"]:before {      
          content: "Resume/CV (File types: pdf, doc, docx, txt)";
        }

        #form-container-ref button[type="submit"] {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: var(--spacing-xs);
          width: fit-content;
          border-radius: 0;
          transition: background-color var(--duration) var(--timing-function);
          margin-top: var(--spacing-sm);
        }

        #form-container-ref button[type="submit"]:hover {
          filter: unset;
          background-color: var(--color-green);
        }

        #form-container-ref button[type="submit"]:after {
          display: block;
          content: "";
          width: 1.4rem;
          aspect-ratio: 1.4;
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 15 12" fill="none"><path d="M9.19225 11.3078L8.4845 10.5885L12.573 6.50001H0.5V5.50001H12.573L8.4845 1.41151L9.19225 0.692261L14.5 6.00001L9.19225 11.3078Z" fill="%23F9F8F6"/></svg>');
        }
      `;
      shadow.appendChild(style);

       const positionInput = shadow.querySelector(
        'input[id="custom#position_apply_for"]'
      );

      if (positionInput) {
        const positionEl = document.querySelector(
          '#shopify-section-template--19028414234842__main > * > * > * > * h1.font-heading'
        );

        if (positionEl) {
          const jobTitle = positionEl.textContent.trim();

          positionInput.value = jobTitle;

          // Trigger input so shadow DOM form logic catches it
          positionInput.dispatchEvent(new Event("input", { bubbles: true }));
        } else {
          console.log("No job title found, skipping prefill");
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
